import SpinnerPurple from "../../svgs/spinner.svg?react";
import { SpinnerWrapper, SpinningEmoji } from "./styledComponents";

export const SpinnerBasic = ({ className = "" }) => (
  <SpinnerWrapper className={className}>
    <SpinningEmoji>
      <SpinnerPurple />
    </SpinningEmoji>
  </SpinnerWrapper>
);
